<template>
  <div class="chat-container w-100 position-relative bg-white">
    <div id="hotel-help"></div>
    <template v-if="!help_select">
      <div class="container px-4 w-100 py-3">
        <router-link :to="'/'+getMerchant().code+'/concierge/account'">
          <img src="../../../../assets/img/icon/back-arrow.png" class="mb-1 mt-2 cursor-pointer" width="15">
        </router-link>
        <div class="row no-gutters pt-2 m-0 w-100">
          <div class="col-12 mb-2 pb-2">
            <p class="mb-0 body-1-1 text-26">Help Center</p>
            <p class="mb-0 body-3-3-1">All questions ever asked are here</p>
          </div>
          <div class="col-12">
            <input type="text" placeholder="Search help here..." ref="search" class="w-100 border-none body-2-1 ls-0-1 bg-light search-custom rounded-6" v-model="search" />
          </div>
        </div>
      </div>
      <div id="help-detail"></div>
      <div class="container px-4 pt-4 mb-3 bg-white">
        <p class="mb-0 pb-2 body-2-2 text-16 font-bold" v-if="search == ''">Tentang Guestapp</p>
        <div class="row no-gutters border-bottom cursor-pointer" v-for="data in filter_search" @click="toggleHelp(data)">  
          <div class="col-11">
            <p class="mb-0 pt-3 pb-3 font-semibold body-2-4 text-black text-14">{{data.title}}</p>
          </div>
          <div class="col-1 text-right align-self-center">
            <img src="../../../../assets/img/icon/next-grey.png" class="position-relative" width="16" style="top: -2px">
          </div>
        </div>
      </div>
      <div class="container px-4 pt-4 mb-3 bg-white">
        <p class="mb-0 pb-2 body-2-2 text-16 font-bold" v-if="search == ''">Bantuan Dasar</p>
        <div class="row no-gutters border-bottom cursor-pointer" v-for="data in filter_search" @click="toggleHelp(data)">  
          <div class="col-11">
            <p class="mb-0 pt-3 pb-3 font-semibold body-2-4 text-black text-14">{{data.title}}</p>
          </div>
          <div class="col-1 text-right align-self-center">
            <img src="../../../../assets/img/icon/next-grey.png" class="position-relative" width="16" style="top: -2px">
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="position-relative z-index-1028">
        <div class="row no-gutters justify-content-center">
          <div class="fixed-top d-block nav-bottom">
            <div class="custom-container-fluid px-0">
              <div class="row justify-content-center no-gutters">
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                  <div class="bg-white box-shadow-nav">
                    <div class="container px-4 w-100 pt-1 pb-2">
                      <div class="row no-gutters py-2 m-0 w-100">
                        <div class="col-1" @click="toggleHelp(false)">
                          <img src="../../../../assets/img/icon/back-arrow.png" class="cursor-pointer" width="15">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="height: 52px"></div>
      <div class="container p-4">
        <p class="mb-0 text-10 body-2 font-regular">Help > Detail</p>
        <p class="mb-3 font-extrabold text-24 body-2-2">{{help_select.title}}</p>
        <p class="mb-3 font-regular body-2 lh-25">{{help_select.desc}}</p>
        <p class="mb-3 font-regular body-2 lh-25">{{help_select.desc}}</p>
      </div>
    </template>
    <div style="height: 20px"></div>
    <bottom-navbar></bottom-navbar>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex';
  import BottomNavbar from '@/components/hotel/BottomNavbar';

  export default{
    components: {
      BottomNavbar
    },
    metaInfo(){
      return {
        title: 'Help',
        titleTemplate: this.getMetaTitleTemplate()
      }
    },
    data() {
      return {
        scrollPosition: null,
        search: '',
        help_select: false,
        help : [
          {
            id: 1,
            title: 'Konfirmasi Pembayaran Guestapp',
            desc: 'GuestPro adalah solusi Integrated Property Management System berbasis awan yang akan mengintegrasikan kegiatan-kegiatan operasional terkait mulai dari Front Office , POS, Logistic sampai ke Accounting. Sehingga menghasilkan proses bisnis yang efisien, memudahkan koordinasi, pemecahan masalah dan pengambilan keputusan.'
          },
          {
            id: 2,
            title: 'Front Desk Guest List Daily',
            desc: 'GuestPro adalah solusi Integrated Property Management System berbasis awan yang akan mengintegrasikan kegiatan-kegiatan operasional terkait mulai dari Front Office , POS, Logistic sampai ke Accounting. Sehingga menghasilkan proses bisnis yang efisien, memudahkan koordinasi, pemecahan masalah dan pengambilan keputusan.'
          },
          {
            id: 3,
            title: 'Backdate Mengembalikan Tanggal Sistem',
            desc: 'GuestPro adalah solusi Integrated Property Management System berbasis awan yang akan mengintegrasikan kegiatan-kegiatan operasional terkait mulai dari Front Office , POS, Logistic sampai ke Accounting. Sehingga menghasilkan proses bisnis yang efisien, memudahkan koordinasi, pemecahan masalah dan pengambilan keputusan.'
          },
          {
            id: 4,
            title: 'Menghapus Cache dan Cookies di Browser Firefox dan Chrome',
            desc: 'GuestPro adalah solusi Integrated Property Management System berbasis awan yang akan mengintegrasikan kegiatan-kegiatan operasional terkait mulai dari Front Office , POS, Logistic sampai ke Accounting. Sehingga menghasilkan proses bisnis yang efisien, memudahkan koordinasi, pemecahan masalah dan pengambilan keputusan.'
          }
        ],
      }
    },
    computed:{
      filter_search(){
        return this.help.filter((item)=>{
          return item.title.toString().toLowerCase().match(this.search.toLowerCase())
        })
      }
    },
    mounted() {
      window.addEventListener('scroll', this.updateScroll);
      document.getElementById('hotel-help').scrollIntoView({
        behavior: 'smooth'
      });
    },
    methods: {
      ...mapGetters(['getMerchant','getMetaTitleTemplate']),
      updateScroll() {
        this.scrollPosition = window.scrollY
      },
      toggleHelp(data, id){
        this.help_select = data
        document.getElementById('hotel-help').scrollIntoView({
          behavior: 'smooth'
        });
      },
    }
  }
</script>
<style scoped>

.left-0-d{
  left: 0!important
}

@media screen and (max-width: 655px) {
  .mobile-none{
    display: none !important;
  }
} 
</style>


// WEBPACK FOOTER //
// src/pages/hotel/concierge/account/Help.vue